import React from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import { Flex, Group, Stack, Text } from '@mantine/core';
import Button from '../../components/elements/Button';

interface ModalDownloadProps {
  opened: boolean;
  title: string;
  onClose: () => void;
  onConfirm: (data: any) => void;
}

const ModalDownload: React.FC<ModalDownloadProps> = ({
  opened,
  title,
  onClose,
  onConfirm
}) => {
  return (
    <ModalWrapper title={title} isVisible={opened} onClose={onClose}>
      <Stack>
        <Text>Are you going to download with FMSTR?</Text>
        <Group justify="space-between" gap={16}>
          <Flex flex={1}>
            <Button
              full
              variant="outline"
              onClick={() => onConfirm({ status: 0 })}
            >
              No, download without FMSTR
            </Button>
          </Flex>
          <Flex flex={1}>
            <Button full onClick={() => onConfirm({ status: 1 })}>
              Yes with FMSTR
            </Button>
          </Flex>
        </Group>
      </Stack>
    </ModalWrapper>
  );
};

export default ModalDownload;
